import React from "react";

export default function OpenSource() {
  return (
    <section id="opsrcsection">
      <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 container mx-auto flex flex-col items-center">
        <h1 id="opsrc" className="title-font !bg-gradient-to-br !from-pink-300 !via-purple-300 !to-indigo-400 !text-4xl font-extrabold inline-block text-transparent bg-clip-text sm:text-5xl">Open Source</h1>
      </div>
      <br />
    </section>
  );
}
